import { useMemo } from 'external/react';
import useAccounting from 'context/accounting-context/hook';
import { ROW_HEIGHT, columns } from './PayoutsTableProperties';

const PayoutsTableFillerRow = () => {
  const { payouts, payoutsPaging } = useAccounting();
  const pageSize = useMemo(() => payoutsPaging ? payoutsPaging.pageSize : 0, [payoutsPaging]);
  if (payouts.length >= pageSize) return null;
  return (
    <tr style={{ pointerEvents: 'none' }}>
      <td
        colSpan={columns.length}
        rowSpan={Math.max(0, pageSize - payouts.length)}
        style={{ border: 'none', height: `${(pageSize - payouts.length) * ROW_HEIGHT}px` }}
      />
    </tr>
  );
};

export default PayoutsTableFillerRow;